import { type MutationHookOptions, useMutation } from "@apollo/client";
import { VerifySignInMutation } from "./../graphql/mutations";

export const useVerifyEmail = (options?: MutationHookOptions) => {
  return useMutation(VerifySignInMutation, options);
};
